export default __webpack_public_path__ + "static/media/icon_list_downloads.3c77fe2e.svg";